export default {
  topMenu: {
    signin: 'topMenu.signin',
    about: 'topMenu.about',
    support: 'topMenu.support',
    newsResources: 'topMenu.newsResources',
  },
};
